"use client";

import type { ComponentProps } from "react";
import { createContext, useContext, useMemo } from "react";

import { useHeadersValues } from "../request/hooks/useHeadersValues";
import { createOpenApiClient } from "../request/openApiClient";
import { useSession } from "../session/hooks/useSession";

type OpenApiContext = {
  openApiClient: ReturnType<typeof createOpenApiClient>;
};

const openApiContext = createContext<OpenApiContext>({
  openApiClient: null as unknown as ReturnType<typeof createOpenApiClient>,
});

export const OpenApiProvider = ({
  children,
}: Omit<ComponentProps<typeof openApiContext.Provider>, "value">) => {
  const headersValues = useHeadersValues();
  const { setToken } = useSession();

  const openApiClient = useMemo(
    () =>
      createOpenApiClient({
        headersValues: headersValues.current,
        onTokenRefresh: setToken,
      }),
    [headersValues.current.token, headersValues.current.locale],
  );

  return (
    <openApiContext.Provider value={{ openApiClient }}>
      {children}
    </openApiContext.Provider>
  );
};

export const useOpenApiClient = () => useContext(openApiContext);
